import React from "react";
import { Input } from "../../../../../controls";

const InputReturnQty = ({ item, handleInpChg }) => {
  return (
    <div className="flex flex-col gap-1">
      <Input
        className="shadow-xs"
        variant="outlined"
        type="number"
        placeholder="$ 0.00"
        value={item.qty}
        inputProps={{ maxLength: 200 }}
        onChange={(e) => {
          const inputValue = parseFloat(e.target.value) || 0;
          const currentLength = e.target.value.length;
          const prevLength = item.totalReceiveQty.toString().length;

          const isValidInput =
            item.totalReceiveQty >= inputValue || prevLength > currentLength;

          if (isValidInput && inputValue >= 0) {
            handleInpChg({
              key: item.key,
              name: "qty",
              value: e.target.value,
            });
          }
        }}
        sx={{
          maxWidth: "120px",
          "& .MuiInputBase-root": {
            padding: "0px 0px",
            maxWidth: "150px",
          },
          "& .MuiInputBase-input": {
            padding: "4px 10px",
            fontSize: "14px",
          },
        }}
      />
      <span className="text-gray-500 text-[11px] font-medium pl-1 uppercase">
        Ordered Qty: {item.totalReceiveQty}
      </span>
    </div>
  );
};

export default InputReturnQty;
